import * as Yup from "yup";

const USERNAME_ALLOWED_REGEX = /^[a-z0-9]+$/;

export const LoginSchema = Yup.object({
  usernameOrEmail: Yup.string().required(
    "auth.validation.usernameOrEmailRequired",
  ),
  password: Yup.string().required("auth.validation.passwordRequired"),
});

export const RegisterSchema = Yup.object({
  name: Yup.string().trim().required("auth.validation.nameRequired"),
  username: Yup.string()
    .trim()
    .min(3, "auth.validation.usernameMinLength")
    .matches(USERNAME_ALLOWED_REGEX, "auth.validation.usernameAllowedChars")
    .required("auth.validation.usernameRequired"),
  email: Yup.string()
    .trim()
    .email("auth.validation.invalidEmail")
    .required("auth.validation.emailRequired"),
  password: Yup.string()
    .min(8, "auth.validation.passwordMinLength")
    .required("auth.validation.passwordRequired"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "auth.validation.passwordsMustMatch")
    .required("auth.validation.confirmPasswordRequired"),
  purpose: Yup.string()
    .oneOf(
      ["super_admin", "solution_provider", "reseller"],
      "auth.validation.purposeRequired",
    )
    .required("auth.validation.purposeRequired"),
});

export const ChangePasswordSchema = Yup.object({
  currentPassword: Yup.string().required(
    "auth.validation.currentPasswordRequired",
  ),
  newPassword: Yup.string()
    .min(8, "auth.validation.passwordMinLength")
    .required("auth.validation.newPasswordRequired"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "auth.validation.passwordsMustMatch")
    .required("auth.validation.confirmPasswordRequired"),
});

export const ResetPasswordSchema = Yup.object({
  password: Yup.string()
    .min(8, "auth.validation.passwordMinLength")
    .required("auth.validation.newPasswordRequired"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "auth.validation.passwordsMustMatch")
    .required("auth.validation.confirmPasswordRequired"),
});
